export default __webpack_public_path__ + "static/media/IMG_0334 copie.bd70ad5a.jpg";